/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const AndroidForward = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M11 3.55728L12.0639 2.5L20.5593 10.9427C21.1469 11.5266 21.1469 12.4734 20.5593 13.0573L12.0639 21.5L11 20.4427L18.7408 12.75H3V11.25H18.7408L11 3.55728Z"
                        fill={color}
                    />
                </svg>
        );
    };
